// packages import
import { Maybe } from 'graphql/jsutils/Maybe'
import { FC } from 'react'

// component imports

// others
import { Office } from '../../../../generated'
import OfficeDropdown from '../../common/OfficeDropdown'

interface OfficeFilterProps {
  officeName: any
  setReportFilters: any
  isProfitCenter?: boolean
}

const OfficeFilter: FC<OfficeFilterProps> = ({ officeName, setReportFilters, isProfitCenter = true }) => {
  const handleOfficeChange = (value: Maybe<Office>) => {
    setReportFilters((prev: any) => ({ ...prev, profitCenter: value?.name }))
  }

  return <OfficeDropdown selectedOffice={officeName} sx={{ minWidth: 200 }} onChange={handleOfficeChange} isProfitCenter={isProfitCenter} />
}

export default OfficeFilter
